import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Tag, Result, message, BackTop, Spin } from 'antd';
import { LoadingOutlined, SmileOutlined } from '@ant-design/icons';

import ComplaintInfo from "../components/ComplaintInfo";
import ComplaintStep from "../components/ComplaintStep";
import Chat from "../components/Chat";
import Rate from "../components/Rate";
import Collapse from '../components/StepsCollapse'
import { useNavigate, useParams } from 'react-router-dom';
import Login from "./Login"
import { isEmpty } from 'lodash';
import ComplaintService from "../utils/api/complaints";
import OrderUsers from '../components/Generals/OrderUsers/OrderUsers';
import LayoutPage from '../layouts/Main';


export default function ComplaintDetails() {
  let { id } = useParams();
  let role = localStorage.getItem('role');
  const [complaint, setComplaint] = useState({});
  const [reload, setReload] = useState(false)
  let token = localStorage.getItem('token');


  useEffect(() => {
    ComplaintService.GetComplaint(id)
    .then(response => {
      setComplaint(response.data)
    })
    .catch(error => {
      console.log(error)
    })

  }, [reload])


  if (token == null) {
    return <Login />
  } else {
    return (
      <LayoutPage>
        {
          (Object.entries(complaint).length === 0) ?
            <Row gutter={[12, 12]} justify="center" align='middle'>
              <Col xs={24} style={{ textAlign: 'center' }} >
                <Spin size="large" indicator={<LoadingOutlined style={{ fontSize: 90 }} spin />} tip="Cargando..." />
              </Col>
            </Row>
            :
            <Row gutter={[12, 12]}>

              <Col xs={24} lg={16} xl={16} >

                <ComplaintInfo
                  details={complaint.queja}
                  reload={reload}
                  role={role}
                  token={token}
                  setReload={setReload}
                />

              </Col>
              <Col xs={24} md={24} lg={8} xl={8}>
                <Row gutter={[12, 12]}>
                  <Col xs={24} >
                    <OrderUsers data={complaint} token={token} op={2} />

                  </Col>
                  <Col xs={24}>
                    <ComplaintStep info={complaint.queja.logs} />
                  </Col>
                </Row>

              </Col>
            </Row>
        }
        <BackTop />
      </LayoutPage>
    )
  }
}
